import React from "react";
import { fileUrl } from "@/lib/api";

// Fallback placeholder images from design guidelines
const FALLBACKS = {
  hero: "https://images.unsplash.com/photo-1575747503976-5e6e96a13504?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxNTUElMjBmaWdodGVyJTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg5NDczMjc0fDA&ixlib=rb-4.1.0&q=85",
  fighter: "https://images.unsplash.com/photo-1618517048289-4646902edaf5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxib3hpbmclMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODk0NzMyNzR8MA&ixlib=rb-4.1.0&q=85",
  athlete2: "https://images.unsplash.com/photo-1681203888755-bd61fe3558eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxib3hlciUyMHBvcnRyYWl0JTIwZGFya3xlbnwwfHx8fDE3ODk0NzMyNzR8MA&ixlib=rb-4.1.0&q=85",
  ring: "/event-cage.webp",
  gloves: "https://images.unsplash.com/photo-1549719386-74dfcbf7dbed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxib3hpbmclMjByaW5nJTIwZGFya3xlbnwwfHx8fDE3ODk0NzMyNzR8MA&ixlib=rb-4.1.0&q=85",
};

export const IMG = FALLBACKS;

export default function SmartImage({ path, fallback = "fighter", alt = "", className = "", ...rest }) {
  const src = path ? fileUrl(path) : FALLBACKS[fallback] || FALLBACKS.fighter;
  return <img src={src} alt={alt} loading="lazy" className={className} {...rest} />;
}
